import ActionTypes from "../../../../constants/ActionTypes";
import { IFetchProductInsuranceAction, IEnrichProductInsuranceAction, IProductInsuranceState } from "./types";

export function requestProductInsurance(): IFetchProductInsuranceAction {
  return {
    type: ActionTypes.PRODUCT.FETCH_PRODUCT_INSURANCE,
  };
}

export function setProductInsurance(productInsurance: object) {
  return {
    type: ActionTypes.PRODUCT.SET_PRODUCT_INSURANCE,
    payload: productInsurance
  };
}

export function enrichProductInsuranceAction(productInsurance: IProductInsuranceState): IEnrichProductInsuranceAction {
  return {
    type: ActionTypes.PRODUCT.ENRICH_PRODUCT_INSURANCE,
    payload: { productInsurance }
  };
}

export function setSelectedInsurance(selectedInsurance: object | null) {
  return {
    type: ActionTypes.PRODUCT.SET_SELECTED_INSURANCE,
    payload: selectedInsurance
  };
}

export function clearSelectedInsurance() {
  return {
    type: ActionTypes.PRODUCT.CLEAR_SELECTED_INSURANCE,
  };
}


